<template>
  <div id="threeDSecure-page">
    <section class="main-content">
      <!-- Error message if the timer runs out or the payment fails -->
      <b-message v-if="authError" id="auth-error" type="is-danger">
        <b>Something went wrong during the authorization process!</b>
        <p>
          Please try again, or contact us directly at
          <b>0860 23 24 25</b>
        </p>
        <hr class="details-divider" />
        <div v-for="error in authBookingResult.errors" :key="error.index">
          <span v-if="error.errorWarningAttributeGroup">
            {{ error.errorWarningAttributeGroup.shortText }}
          </span>
          <span v-else> <b>Unformatted Error:</b> {{ error }} </span>
        </div>
        <b-button
          style="margin-top: 2rem;"
          class="back-button"
          tag="router-link"
          to="/"
          type="is-link"
          >Back to search</b-button
        >
      </b-message>

      <!-- Loading message with timer that will diplay until the timer runs out or the payment fails   -->
      <b-message v-if="!authError">
        <div class="processing-payment">
          <b
            >We are busy processing your payment. We will redirect you in
            {{ Math.floor(remainingTime / 60) }}:{{
              String(remainingTime % 60).padStart(2, "0")
            }}
            minutes. Please do not refresh the page<span
              class="period-loading-throbber"
            ></span
          ></b>
        </div>
      </b-message>

      <!-- Loading message until the banking OTP iframe is displayed  -->
      <b-message v-if="!authError && fetchingBankOTPMessage">
        <div class="processing-payment">
          <b>Fetching Banking OTP</b>
          <div class="loading-throbber"></div>
        </div>
      </b-message>

      <!-- Loading message after the banking OTP iframe is closed  -->
      <b-message v-if="!authError && !fetchingBankOTPMessage">
        <div class="processing-payment">
          <b>Authorizing Payment</b>
          <div class="loading-throbber"></div>
        </div>
      </b-message>

      <iframe
        v-if="iframeOpen"
        style="display: block; height: calc(100vh - 110px);"
        height="calc(100vh - 110px)"
        width="100%"
        name="threeDSecureIFrame"
        id="threeDSecureIframe"
      >
      </iframe>
      <!-- change target to _blank for new tab instead of iframe -->
      <form
        target="threeDSecureIFrame"
        method="post"
        :action="threeDSecureUrl"
        id="threeDSecureForm"
        name="threeDSecureForm"
      >
        <input
          v-for="(param, index) in threeDSecureParamMap"
          :key="'input' + index"
          type="hidden"
          :name="param.key"
          :value="param.value"
        />
      </form>
    </section>
  </div>
</template>

<script>
import Api from "../services/Api.service.js";
import { mapState } from "vuex";

export default {
  name: "threeDSecure",
  data: function() {
    return {
      timeOutCount: 0,
      threeDSecureUrl: undefined,
      threeDSecureParamMap: [],
      checkingRedirect: null,
      authError: undefined,
      iframeOpen: true,
      remainingTime: 180, // 3 minutes in seconds
      fetchingBankOTPMessage: true
    };
  },
  computed: {
    ...mapState([
      "selectedFlights",
      "flags",
      "priceResponse",
      "searchParameters",
      "products",
      "paymentMethodResponse",
      "paymentOptions",
      "cardDetails",
      "bookingResponse",
      "baggageCost",
      "allFlights",
      "bookBody",
      "authBookingResult",
      "session"
    ])
  },
  methods: {
    async construct3DSecureRedirectUrl() {
      if (this.bookingResponse.threeDSecureParameters) {
        this.threeDSecureUrl = this.bookingResponse.threeDSecureParameters.find(
          e => e.key == "TARGET_URL"
        ).value; // url params
        this.bookingResponse.threeDSecureParameters.forEach(e => {
          if (e.post && e.key !== "TermUrl") {
            const pair = {};
            pair.key = e.key;
            // pair.value = encodeURIComponent(e.value);
            pair.value = e.value;
            this.threeDSecureParamMap.push(pair);
          }
          if (e.key == "TermUrl") {
            const pair = {};
            pair.key = "TermUrl";
            // pair.value = encodeURIComponent(process.env.VUE_APP_BASE_API_URL + "/three-d-redirect/" + this.session);
            pair.value =
              process.env.VUE_APP_BASE_API_URL +
              "/three-d-redirect/" +
              this.session;
            this.threeDSecureParamMap.push(pair);
          }
          this.fetchingBankOTPMessage = false;
        });
      } else {
        this.$router.push('failure');
      }
      return true;
    },
    async authorizeBooking(data, size) {
      this.stopRediectTimer();
      this.stopDisplayTimer();
      let bookBody = this.bookBody;
      bookBody.bookingRequestData = this.bookingResponse.data;
      bookBody.gatewayPostResponseParameters = {
        data: data,
        size: size
      };
      bookBody.paymentReturnURL = null;
      try {
        let authResult = await Api.authorizeBooking(bookBody);
        this.$store.commit("setAuthBookingResult", authResult.data);
        this.iframeOpen = false;
        if (
          authResult.data.errors != null &&
          authResult.data.errors.length > 0
        ) {
          this.authError = true;
        } else {
          this.$store.commit("setBookingResponse", authResult.data);
          this.$router.push("confirmation");
        }
      } catch (error) {
        console.error("Error authorizing booking:", error);
      }
    },

    async failedAuthorizeBooking(data, size) {
      this.stopRediectTimer();
      this.stopDisplayTimer();
      let bookBody = this.bookBody;
      bookBody.bookingRequestData = this.bookingResponse.data;
      bookBody.gatewayPostResponseParameters = {
        data: data,
        size: size
      };
      bookBody.paymentReturnURL = null;
      try {
        let authResult = await Api.authorizeBooking(bookBody);
        this.$store.commit("setAuthBookingResult", authResult.data);
        this.iframeOpen = false;
        if (authResult) {
          this.authError = true;
        }
      } catch (error) {
        console.error("Error authorizing booking:", error);
      }
    },

    async startRedirectTimer() {
      let state = this;
      this.checkingRedirect = setInterval(async function() {
        state.timeOutCount++;
        console.log(state.timeOutCount);
        console.log("Polling: will check redirect");
        state.checkRedirectStatus();
      }, 3000); //every 3 seconds
    },

    async startDisplayCountdown() {
      this.remainingTime = 180; // Reset to 3 minutes
      this.displayCountdownInterval = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
          //console.log(this.remainingTime);
        } else {
          this.stopDisplayTimer();
          this.authError = true; //display failure card
        }
      }, 1000); //every 1 second
    },

    stopRediectTimer() {
      clearInterval(this.checkingRedirect);
    },

    stopDisplayTimer() {
      clearInterval(this.displayCountdownInterval);
    },

    //if it has been three minutes, you send nul null and cancel clear interval
    async checkRedirectStatus() {
      let state = this;
      if (state.timeOutCount == 60) {
        //60 x 3000ms = 180000ms or 3 min
        console.log("Timer timed out");
        state.failedAuthorizeBooking(null, null);
        state.authError = true; //display failure card
        return;
      }
      try {
        let result = await Api.checkRedirectStatus(state.$store.state.session);
        if (result.data.success) {
          console.log("redirect complete");
          state.stopDisplayTimer();
          state.authorizeBooking(result.data.data, result.data.size);
        }
      } catch (error) {
        console.error("Error checking redirect status:", error);
      }
    }
  },
  async mounted() {
    await this.construct3DSecureRedirectUrl();
    // this.checkRedirectStatus();
    if (this.threeDSecureUrl) {
      document.getElementById("threeDSecureForm").submit();
    }
  },
  beforeDestroy() {
    this.stopRediectTimer();
    this.stopDisplayTimer();
  },
  created() {
    this.startRedirectTimer();
    this.startDisplayCountdown();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

@media (max-width: 781px) {
  .multiline-fix {
    margin-bottom: 0.75em !important;
    * {
      margin-right: 0 !important;
      width: 100% !important;
    }
    flex-wrap: wrap;
  }
}

.steps {
  grid-area: steps;
  align-self: start;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column-reverse;
}

.passenger-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
}

.width-100 {
  width: 100%;
}

.no-borders {
  border: none;
}

.how-it-works {
  font-size: 0.8em;
  color: $primary-color;
  text-decoration: underline;
  cursor: pointer;
}

.margin-bottom-small {
  margin-bottom: 0.75em !important;
}

.block-2,
.block-3 {
  max-width: 600px;
}

.margin-bottom {
  margin-bottom: 1.5em !important;
}

.bag-input {
  margin-bottom: 0.5em;
  margin-top: 0.5em;
  font-size: 12px;
}

.payment-option-charge {
  font-size: 12px;
  margin-top: 1em;
  color: #23d160;
  font-weight: bold;
}

.padding-bottom {
  padding-bottom: 0.75em;
}

.redeem-notice {
  font-size: 0.8em;
  color: darken($grey, 30%);
  margin-bottom: 0.75em;
}

.passenger-block {
  margin-bottom: 1.25em;
  background: $light;
  padding: 0.75em;
  width: 100%;
  border-radius: 8px;
  border-left: 4px solid $secondary-color;
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
}

.no-wrap {
  white-space: nowrap;
}

.modal-close {
  padding: 0.2em;
  display: flex;
  justify-content: flex-end;
}

.mobile-review-modal {
  z-index: 11;
  margin-top: 80px;
}

.dev-only {
  padding: 0.4em;
  margin: 15px 0;
  width: fit-content !important;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid black;
  background: lightcoral;
  border-radius: 6px;
  color: white;
}

.rotate-in-enter-active {
  animation: slide-in-left-less 0.15s cubic-bezier(1, 0.5, 0.8, 1) both;
}

.passenger-type {
  width: fit-content;
  margin-bottom: 1em;
}

#details-page {
  border-radius: 8px;
  max-width: 88%;
}

.search-overview {
  font-size: 0.8em;
}

.container-div {
  display: flex;
  width: 90%;
  margin: 0 0.5em;
}

form {
  width: 100%;
}

form,
#threeDSecure-page {
  margin: 0 auto 1em auto;
  margin-bottom: 0.67em;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  max-width: -webkit-fill-available;
  .booking-button {
    padding: 0.4em;
    border: 1px solid $primary-dark;
    background: $primary-color;
    border-radius: 6px;
    cursor: pointer;
    color: white;
    .booking-prompt {
      color: white !important;
    }
  }
}
.block-navigation-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-evenly;
}
.block-navigation {
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
  border-radius: 8px;
  background: $light;
  div {
    width: auto;
    cursor: pointer;
    padding: 0.4em 1em;
  }
  span {
    color: darken($primary-dark, 30%);
  }
  span + i {
    margin-left: 0.5em;
  }
  i + span {
    margin-left: 0.5em;
  }
}

.payment-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block-heading {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 0.75em;
}

.mobile-toolbar {
  width: 100%;
  margin-bottom: 1em;
  background: white;
  padding: 0.75em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid lightgray;
}

.main-content {
  margin: 0 0.75rem;
}

@media (min-width: 781px) {
  .trip-reivew {
    margin: 0;
    grid-area: review;
    align-self: start;
  }

  .container-div {
    width: 48%;
  }

  .container-div:nth-child(3) {
    margin-right: auto;
  }

  .main-content {
    grid-area: main;
  }

  #threeDSecure-page {
    background: none;
    border: none;
    box-shadow: none;
    margin: 2em auto;
    display: grid;
    padding-top: 0;
    min-width: 860px;
    max-width: 1080px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-column-gap: 0.75em;
    grid-template-areas: "main main main";
  }

  .block-navigation-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    * + * {
      margin-left: 0.75em;
    }
  }
  .multiline-fix {
    flex-wrap: nowrap !important;
  }
  .is-column {
    flex-direction: column;
  }
  form {
    min-width: 400px;
    align-self: start;
    grid-area: form;
    border-radius: 8px;
    max-width: -webkit-fill-available;
  }

  .passenger-block {
    padding: 1.5em;
  }

  .form-errors {
    align-self: flex-start;
    width: 100%;
    grid-area: review;
    background: $light;
    padding: $standard-padding;
    border-radius: 8px;
    box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
    max-width: -webkit-fill-available;
  }
  .block-heading {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    margin-top: 0.75em;
    white-space: nowrap;
  }
}
</style>

<style lang="scss">
.control-label {
  width: 100%;
  align-items: center;
  display: flex;
  img {
    height: 30px;
  }
}

.control .help.counter {
  display: none !important;
}

.square-list {
  list-style-type: square !important;
}

@media (max-width: 781px) {
  .label {
    font-size: 10px !important;
  }
}

@media (min-width: 781px) {
  .field-max {
    max-width: 200px !important;
  }
  .limit-select {
    max-height: 250px !important;
  }
}

.processing-payment {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
  gap: 1em;
}

//circular throbber
.loading-throbber {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.loading-throbber:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #000;
  border-color: #000 transparent #000 transparent;
  animation: loading-throbber 1.2s linear infinite;
}
@keyframes loading-throbber {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

//three full stop throbber
@keyframes period-throbber {
  0% {
    content: ".";
  }
  33% {
    content: "..";
  }
  66% {
    content: "...";
  }
  100% {
    content: ".";
  }
}

.period-loading-throbber::after {
  content: "";
  display: inline-block;
  width: 1em;
  text-align: left;
  animation: period-throbber 1s infinite;
}
</style>
